export const rolesStatePermissions = [
  'permissoesPABX',
  'permissoesRelatorioPABXChamadasAcesso',
  'permissoesRelatorioPABXChamadasOuvirLigacoes',
  'permissoesRelatorioPABXChamadasTotal',
  'permissoesRelatorioPABXConferenciasAcesso',
  'permissoesRelatorioPABXConferenciasOuvirLigacoes',
  'permissoesRelatorioPABXConferenciasTotal',
  'permissoesMonitorRamal',
  'permissoesMonitorRamalOuvirLigacoes',
  'permissoesMonitorRamalTotal',
  'permissoesCallCenterCadastroOperadoresLeitura',
  'permissoesCallCenterCadastroOperadoresEditar',
  'permissoesCallCenterCadastroOperadoresTotal',
  'permissoesCallCenterCadastroPausasLeitura',
  'permissoesCallCenterCadastroPausasEditar',
  'permissoesCallCenterCadastroPausasTotal',
  'permissoesCallCenterCadastroFilasLeitura',
  'permissoesCallCenterCadastroFilasEditar',
  'permissoesCallCenterCadastroFilasTotal',
  'permissoesCallCenterCadastroDepartamentosLeitura',
  'permissoesCallCenterCadastroDepartamentosEditar',
  'permissoesCallCenterCadastroDepartamentosTotal',
  'permissoesCallCenterRelatorioOperadorLeitura',
  'permissoesCallCenterRelatorioOperadorOuvirLigacoes',
  'permissoesCallCenterRelatorioOperadorHistoricoLigacoes',
  'permissoesCallCenterRelatorioOperadorOuvirHistorico',
  'permissoesCallCenterRelatorioOperadorTotal',
  'permissoesCallCenterRelatorioFilaLeitura',
  'permissoesCallCenterRelatorioFilaOuvirLigacoes',
  'permissoesCallCenterRelatorioFilaHistoricoLigacoes',
  'permissoesCallCenterRelatorioFilaOuvirHistorico',
  'permissoesCallCenterRelatorioFilaTotal',
  'permissoesCallCenterRelatorioDisponibilidadeLeitura',
  'permissoesCallCenterRelatorioDisponibilidadeTotal',
  'permissoesCallCenterMonitorFilasAcesso',
  'permissoesCallCenterMonitorFilasPausa',
  'permissoesCallCenterMonitorFilasAdicionar',
  'permissoesCallCenterMonitorFilasDeslogar',
  'permissoesCallCenterMonitorFilasOuvirLigacoes',
  'permissoesCallCenterMonitorFilasTotal',
  'permissoesCallCenterManutencaoOperadoresAcesso',
  'permissoesPesquisaSatisfacaoCadastroLeitura',
  'permissoesPesquisaSatisfacaoCadastroEditar',
  'permissoesPesquisaSatisfacaoCadastroTotal',
  'permissoesPesquisaSatisfacaoRelatorioAcesso',
  'permissoesPesquisaSatisfacaoRelatorioOuvirMsg',
  'permissoesPesquisaSatisfacaoRelatorioHistoricoChamadas',
  'permissoesPesquisaSatisfacaoRelatorioAudioHistorico',
  'permissoesPesquisaSatisfacaoRelatorioTotal',
  'permissoesUsuariosCadastroPerfilLeitura',
  'permissoesUsuariosCadastroPerfilEditar',
  'permissoesUsuariosCadastroPerfilTotal',
  'permissoesUsuariosCadastroUsuarioLeitura',
  'permissoesUsuariosCadastroUsuarioEditar',
  'permissoesUsuariosCadastroUsuarioTotal',
  'permissoesUsuariosAuditoriaVisualizar',
  'permissoesUsuariosAuditoriaTotal',
  'permissoesUsuariosTokenVisualizar',
]

export const rolesStateArrayPermissions = [
  'selectedRamaisRelatoriosPABX',
  'selectedRamaisMonitorRamais',
  'selectedTagsRelatoriosPABX',
  'selectedTagsPesquisaSatisfacao',
  'selectedConferencias',
  'selectedFilas',
  'selectedDepartamentos',
  'selectedOperadores',
  'selectedPesquisasSatisfacao',
]
